<script lang="ts">
    import { onMount } from 'svelte'
    import Showcase from './z/showcase.svelte'

    let debug = ''
    onMount(async () => {
        debug = '<b>Versão Zandu:</b>\n<span>' + getScriptParam('v') + '</span>\n'
        debug += '<b>userAgent:</b>\n<span>' + window.navigator.userAgent + '</span>\n'
        debug += '<b>width X height:</b>\n<span>' + window.screen.width + ' x ' + window.screen.height + '</span>\n'
        debug += '<b>api.isWindows:</b>\n<span>' + window.api.utils.utils.isWindows() + '</span>\n'
        debug += '<b>api.isMacOS:</b>\n<span>' + window.api.utils.utils.isMacOS() + '</span>\n'
        debug += '<b>api.isIOS:</b>\n<span>' + window.api.utils.utils.isIOS() + '</span>\n'
        debug += '<b>api.isMobile:</b>\n<span>' + (await window.api.utils.utils.isMobile()) + '</span>\n'
        debug += '<b>navigator.maxTouchPoints:</b>\n<span>' + navigator.maxTouchPoints + '</span>\n'
    })

    function getScriptParam(param) {
        const scripts = document.getElementsByTagName('script') as any
        for (const script of scripts) {
            const qs = script.src.split('?')
            if (qs.length <= 1) {
                continue
            }
            const urlParams = new URLSearchParams('?' + qs[1])
            const result = urlParams.get(param)
            return result
        }
    }
</script>

<div class="m-3 dbg">
    {@html debug}
</div>

<!-- vitrine dos componentes: /debug?showcase=1 (?fields=1 continua valendo, era o endereço antigo) -->
{#if new URLSearchParams(window.location.search).get('showcase') || new URLSearchParams(window.location.search).get('fields')}
    <Showcase />
{/if}

<style>
    .dbg {
        white-space: pre-line;
    }
    :global(.dbg b) {
        color: #888;
    }
    :global(.dbg span) {
        padding-bottom: 8px;
        display: inline-block;
    }
</style>
